'use strict';

var support = getSupport();

(function VariantSelect() {
  var dataProduct = document.querySelector('[data-product]');
  if (!dataProduct) return;
  
  var currentVariant = JSON.parse(document.querySelector('[data-current-variant]').innerHTML);                         
  
  var lang = JSON.parse(document.querySelector('[data-lang]').innerHTML);
  var variants = JSON.parse(dataProduct.innerHTML).variants;
  var selectList = nodeList('[data-variant-select]');
  
  var el = {
    price: nodeList('[data-product-price]'),
    atc: nodeList('[data-submit-button]'),
    atcText: nodeList('[data-submit-button-text]'),
    formSelect: document.querySelector('select[name="id"]')
  }
  
  selectList.forEach(setEvents);
  inventory(currentVariant);
  
  function setEvents(node) {
    node.addEventListener('change', select);
  }
  
  function select() {
    var selectedOptions = selectList.map(function(select, index) {
      return {
        position: Number(select.getAttribute('data-option-position')) || index + 1,
        value: select.value
      };
    });

    var variant = variants.filter(function(variantItem) {
      return selectedOptions.every(function(option) {
        return variantItem.options[option.position - 1] === option.value;
      });
    })[0];
    
    variant ? updateVariant(variant) : updateNoVariant();
  }
  
  function updateVariant(variant) {
    var price = formatMoney(variant.price);
    var ctaText = variant.available? lang['add_to_cart'] : lang['sold_out'];
    
    el.formSelect.value = variant.id
    el.price.forEach(partial(textContent, price));
    el.atcText.forEach(partial(textContent, ctaText));
    el.atc.forEach(partial(toggleProp, 'disabled', !variant.available));
    window.history.pushState({}, '', '?variant=' + variant.id);
    
    if (variant.featured_image && theme.productGallery) {
      var imageEl = document.querySelector('[data-product-gallery] [data-position="' + variant.featured_image.position  + '"]');
      var position = imageEl ? imageEl.getAttribute('data-index') : null;
      if (position !== null) {
        theme.productGallery.slideTo(position);
      }
    }

    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant }}));
    
    inventory(variant);
  }
  
  function inventory(variant) {
    var elList = nodeList('[data-product-inventory]');
    var productInStock = "In Stock";
    var productOutOfStock = "Out of Stock";
    var productAvailableToOrder = "Available to Order";

    if (!variant.inventory_management) {
      setInventoryText(elList, productAvailableToOrder);
      setCartState(false, lang['add_to_cart']);
      return;
    }

    if (variant.inventory_quantity > 0) {
      setInventoryText(elList, productInStock);
      setCartState(false, lang['add_to_cart']);
      return;
    }

    setInventoryText(elList, productOutOfStock);
    setCartState(true, lang['sold_out']);
    
    function setInventoryText(elList, str) {
      elList.forEach(function(el) {
        el.textContent = str;
      });
    }

    function setCartState(disabled, str) {
      el.atc.forEach(partial(toggleProp, 'disabled', disabled));
      el.atcText.forEach(partial(textContent, str));
    }
  }
  
  function updateNoVariant() {
    el.atc.forEach(partial(toggleProp, 'disabled', true));
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: null }}));
  }
  
  function textContent(str, element) {
    element.textContent = str;
  }
  
  function toggleProp(prop, value, element) {
    value ? element.setAttribute(prop, value) : element.removeAttribute(prop);
  }
})();

(function NavDesktop() {
  var triggers = nodeList('[data-nav-desktop-trigger]');
  var panels = nodeList('[data-nav-desktop-panel]');
  
  triggers.forEach(setEvents);
  
  function setEvents(node) {
    node.addEventListener('click', partial(toggle, node));
  }
  
  function toggle(node) {
    isCollapsed(node) ? expand() : collapse();
  }
  
  function isCollapsed(node) {
    return node.getAttribute('aria-expanded') === 'false';
  }
  
  function expand() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', true);
    });
    
    panels.forEach(function(panel){
     panel.removeAttribute('hidden');
     animate(panel, 'height', 'normal', 540);
    });
  }
  
  function collapse() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', false);
    });
    
    panels.forEach(function(panel){
     panel.setAttribute('hidden', '');
     animate(panel, 'height', 'reverse');
    });
  }
})();


(function NavMobile() {
  var triggers = nodeList('[data-js-mobile-nav]');
  var panel = document.querySelector('[data-nav-mobile]');
  
  setEvents();
  
  function setEvents() {
    triggers.forEach(function(node){
      node.addEventListener('click', partial(toggle, node));
    }); 
  }

  function toggle(node) {
    isCollapsed(node) ? expand() : collapse();
  }
  
  function isCollapsed(node) {
    return node.getAttribute('aria-expanded') === 'false';
  }
  
  function expand() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', true);
    });
    
   panel.removeAttribute('hidden');
   animate(panel, 'translateX', 'normal');
  }
  
  function collapse() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', false);
    });
    
   panel.setAttribute('hidden', '');
   animate(panel, 'translateX', 'reverse');
  }
})();


(function NavCart() {
  var triggers = nodeList('[data-js-cart]');
  var panel = document.querySelector('[data-cart-panel]');
  
  theme.navCart = {
    expand: expand,
    collapse: collapse,
    isCollapsed: isCollapsed
  }
  
  compose(setCartQtyEvents, setEvents)();
  
  function setEvents() {
    triggers.forEach(function(node){
      node.addEventListener('click', partial(toggle, node));
    }); 
  }

  function toggle(node) {
    isCollapsed(node) ? expand() : collapse();
  }
  
  function isCollapsed(node) {
    return panel.hasAttribute('hidden');
  }
  
  function expand() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', true);
    });
    
   panel.removeAttribute('hidden');
   animate(panel, 'cartAnimation', 'normal');
  }
  
  function collapse() {
    triggers.forEach(function(trigger){
      trigger.setAttribute('aria-expanded', false);
    });
    
   panel.setAttribute('hidden', '');
   animate(panel, 'cartAnimation', 'reverse');
  }
})();

function NavCartUpdate(){
  var cartItems = document.querySelector('[data-cart-items]');
      
  fetch('/cart?view=dynamic', {
    method: 'GET'
  })
  .then(response => {
    return response.text();
  })
  .then(responseText => {
    compose(setCartQtyEvents, updateNavQty, undateCartMarkup)(responseText);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
  function undateCartMarkup(responseText) {
    cartItems.innerHTML = responseText;
    if (theme.navCart.isCollapsed()) theme.navCart.expand();
  }
  
  function updateNavQty() {
    var navQty = document.querySelector('[data-js-cart-count]');
    var qtySum = (accumulator, currentValue) => accumulator + currentValue;
    var qtyList = nodeList('[data-cart-panel] [type="number"]');
    var totalQty = qtyList.map(function(node){
      return Number(node.value);
    }).reduce(qtySum);
    
    navQty.textContent = totalQty;
    navQty.setAttribute('data-js-cart-count', totalQty)
  }
};

function setCartQtyEvents(){
  var qtyList = nodeList('[data-cart-panel] [type="number"]');
  qtyList.forEach((node, index)=> node.addEventListener('change', partial(cartUpdate, node)));
}

function cartUpdate(node) {
  var panel = document.querySelector('[data-cart-panel]');
  var id = node.getAttribute('data-variant-id');
  var qty = node.value;
  
  panel.classList.add('cart-updating');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ quantity: qty, id: id })
  })
  .then(response => {
    NavCartUpdate();
    panel.classList.remove('cart-updating');
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

(function cartAdd() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  
  var select = form.querySelector('[name="id"]');
  var quantity = form.querySelector('[name="quantity"]'); 
  
  form.addEventListener('submit', submit);
  
  function submit(evt) {
    evt.preventDefault();

    var formData = {
     'items': [{
      'id': select.value,
      'quantity': quantity.value
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      NavCartUpdate();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
})();


(function Collapsible() {
  var triggers = nodeList('[data-js-collapsible]');
  
  setEvents();
  
  function setEvents() {
    triggers.forEach(function(node){
      node.addEventListener('click', partial(toggle, node));
    }); 
  }

  function toggle(node) {
    isCollapsed(node) ? expand(node) : collapse(node);
  }
  
  function isCollapsed(node) {
    return node.getAttribute('aria-expanded') === 'false';
  }
  
  function expand(trigger) {
    var panel = trigger.nextElementSibling;
    trigger.setAttribute('aria-expanded', true);
    panel.removeAttribute('hidden');
    animate(panel, 'height', 'normal');
  }
  
  function collapse(trigger) {
    var panel = trigger.nextElementSibling;
    trigger.setAttribute('aria-expanded', false);
    panel.setAttribute('hidden', '');
    animate(panel, 'height', 'reverse');
  }
})();


(function ProductReadMore() {
  var triggers = nodeList('[data-toggle-description]');
  
  setActive();
  setEvents();
  
  function setEvents() {
    triggers.forEach(function(node){
      node.addEventListener('click', partial(toggle, node));
    }); 
    
    window.addEventListener('resize', setActive);
  }

  function toggle(node) {
    isCollapsed(node) ? expand(node) : collapse(node);
  }
  
  function isCollapsed(node) {
    return node.getAttribute('aria-expanded') === 'false';
  }
  
  function expand(trigger) {
    var panel = trigger.previousElementSibling;
    trigger.setAttribute('aria-expanded', true);
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }
  
  function collapse(trigger) {
    var panel = trigger.previousElementSibling;
    trigger.setAttribute('aria-expanded', false);
    panel.removeAttribute('style');
  }
  
  function setActive() {
    var description = document.querySelector('[data-description]');
    if (!description) return;
    
    var parent = description.parentElement;
    var trigger = document.querySelector('[data-toggle-description]');
    if (!trigger) return;

    var wasExpanded = trigger.getAttribute('aria-expanded') === 'true';

    parent.removeAttribute('style');
    trigger.setAttribute('aria-expanded', false);

    var fullHeight = parent.scrollHeight;
    var clippedHeight = parent.clientHeight;

    if (fullHeight > clippedHeight + 3) {
      trigger.removeAttribute('hidden');

      if (wasExpanded) {
        trigger.setAttribute('aria-expanded', true);
        parent.style.maxHeight = parent.scrollHeight + 'px';
      }
    } else {
      trigger.setAttribute('hidden', 'hidden');
      trigger.setAttribute('aria-expanded', false);
      parent.removeAttribute('style');
    }
  }
})();


(function Search() {
  var triggerOpen = nodeList('[data-js-search]')[0];
  var triggerClose = nodeList('[data-js-search-close]')[0];
  var headerNodesToHide = nodeList('[data-hide-on-search]');
  
  setEvents();
  
  function setEvents() {
    triggerClose.addEventListener('click', toggleNodesToHide);
    triggerOpen.addEventListener('click', partial(open, triggerOpen));
  }
  
  function open(node) {
    toggleNodesToHide();
    document.getElementById('Search').focus();
  }
  
  function toggleNodesToHide() {
    headerNodesToHide.forEach(function(node){
      node.hasAttribute('hidden')
        ? node.removeAttribute('hidden')
        : node.setAttribute('hidden', true)
    });
  }
})();


(function ProductBackToCollection() {
  var collectionBackLink = document.querySelector('[data-collections-back]');
  if (!collectionBackLink) return;
  
  var handles = collectionBackLink.getAttribute('data-collections-handle').split(',');
  var titles = collectionBackLink.getAttribute('data-collections-title').split(',');
  var referrer = document.referrer.split('/').reverse();
  var isReferrerCollection = referrer[1] === 'collections';
  var referrerCollectionHandle;
  var referrerCollectionQuery;
  
  if (referrer[1] === 'collections') {
    referrerCollectionHandle = referrer[0].split('?')[0];
  	referrerCollectionQuery = referrer[0].split('?')[1];
  } else if (referrer[3] === 'collections') {
    referrerCollectionHandle = referrer[2].split('?')[0];
  	referrerCollectionQuery = referrer[2].split('?')[1];
  }
  
  if (handles.includes(referrerCollectionHandle)) {
    var index = handles.indexOf(referrerCollectionHandle);
    var text = 'BACK TO ' + titles[index];
    var url = referrerCollectionQuery 
    	? '/collections/' + referrerCollectionHandle + '?' + referrerCollectionQuery
        : '/collections/' + referrerCollectionHandle;
    
    collectionBackLink.href = url;
    collectionBackLink.querySelector('span').textContent = text;
  }
  
})();

(function Slider(namespace){
  'use strict';

  var initSequence = compose(publicAPI, setControlsDisabled, setControlsVisibility, setEvents, collate);
  var reInitSequence = compose(setControlsDisabled, setControlsVisibility);
  var triggerClickSequence = compose(setScroll, getScrollOffset, setDirection);

  try {
    namespace.Slider = nodeList('[data-slider]').map(initSequence);
  } catch(error) {
    console.log(error)
  }
  
  function publicAPI(data) {
    return {
      id: data.container.getAttribute('data-slider'),
      elements: {
        container: data.container,
        triggerPrev: data.triggerPrev,
        triggerNext: data.triggerNext,
        track: data.track,
        items: data.items
      },
      reinit: partial(reInitSequence, data),
      canScrollPrev: partial(canScrollPrev, data),
      canScrollNext: partial(canScrollNext, data),
      scrollToStart: partial(scrollToStart, data),
      scrollToEnd: partial(scrollToEnd, data)
    }
  }

  // Get all nodes needed
  function collate(node) {
    return {
      container: node,
      triggerPrev: node.querySelector('[data-slider-trigger-prev]'),
      triggerNext: node.querySelector('[data-slider-trigger-next]'),
      track: node.querySelector('[data-slider-track]'),
      get items() {
        var childrenArray = Array.prototype.slice.call(node.querySelector('[data-slider-track]').children);
        //console.log(childrenArray)
        return childrenArray.filter(function(item) {
          return item.tagName !== 'STYLE';
        })
      },
      get firstItem() {
        return head(this.items);
      },
      get lastItem() {
        return last(this.items);
      }
    }
  }

  function setEvents(data) {
    data.triggerPrev.addEventListener('click', partial(triggerClickSequence, data, 'prev'));
    data.triggerNext.addEventListener('click', partial(triggerClickSequence, data, 'next'));

    var debounceScroll = debounce(partial(setControlsDisabled, data), 66);
    data.track.addEventListener('scroll', debounceScroll);

    return data;
  }

  function setDirection(data, direction) {
    data.direction = direction; 
    return data;
  }

  function findNextItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (; i < items.length; i += 1) {
      var itemBox = items[i].getBoundingClientRect();

       // Item right edge is outside the scroll container
      if (itemBox.right > trackBox.right) {
        return items[i];
        break;
      }
    }
  }

  function findPrevItem(data) {
    var i = 0;
    var trackBox = data.track.getBoundingClientRect();
    var items = data.items;

    for (var i = items.length - 1; i >= 0; i--) {
      var itemBox = items[i].getBoundingClientRect();
      
      // Item left edge is outside the scroll container
      if (itemBox.left < trackBox.left) {
        return items[i];
        break;
      }
    }
  }

  function getScrollOffset(data) {
    var trackBox = data.track.getBoundingClientRect();

    if (data.direction === 'next') {
      var item = findNextItem(data);
      data.offset = trackBox.left - item.getBoundingClientRect().left;
    }

    if (data.direction === 'prev') {
      var item = findPrevItem(data);
      data.offset = trackBox.right - item.getBoundingClientRect().right
    }

    return data;
  }

  // API method: scrollX
  function scrollX(data, offsetX) {
    data.offset = offsetX;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToStart(data) {
    data.offset = data.track.scrollWidth;
    setScroll(data);
  }

  // API method: scrollToStart
  function scrollToEnd(data) {
    var firstItemLeft = head(data.items).getBoundingClientRect().left;
    var lastItemRight = last(data.items).getBoundingClientRect().right;

    data.offset = firstItemLeft - lastItemRight;
    setScroll(data);
  }

  function setScroll(data) {
    data.isScrolling = true;
    data.track.scrollLeft += -data.offset;
  }

  function setControlsDisabled(data) {
    canScrollPrev(data)
      ? data.triggerPrev.removeAttribute('disabled')
      : data.triggerPrev.setAttribute('disabled', true);

    canScrollNext(data)
      ? data.triggerNext.removeAttribute('disabled')
      : data.triggerNext.setAttribute('disabled', true);

    return data;
  }

  function setControlsVisibility(data) {
    // Slider without items
    if (!data.items.length) return data;

    if (hasScrollOverflow(data)) {
      data.triggerPrev.setAttribute('hidden', true);
      data.triggerNext.setAttribute('hidden', true);
    } else {
      data.triggerPrev.removeAttribute('hidden');
      data.triggerNext.removeAttribute('hidden');
    }

    return data;
  }

  function canScrollNext(data) {
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(Math.abs(data.lastItem.getBoundingClientRect().right - data.track.getBoundingClientRect().right) <= 1);
  }

  function canScrollPrev(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return !Boolean(data.track.scrollLeft === 0);
  }

  function hasScrollOverflow(data) { 
    // Slider without items
    if (!data.items.length) return false;

    return Boolean(data.lastItem.getBoundingClientRect().right <= data.track.getBoundingClientRect().right);
  }
})(theme);


(function Collapsible() {
  return nodeList('[data-collapsible-title]').map(getElements).map(setEvents);

  function getElements(trigger) {
    console.log(trigger,getPanelElement(trigger) )
    return {
      trigger: trigger,
      panel: getPanelElement(trigger)
    }
  }

  function setEvents(collapsible) {
    // Prevent application from breaking when markup is not corectly setup
    if (!collapsible.panel) return collapsible;

    console.log(collapsible)

    collapsible.trigger.addEventListener('click', partial(toggle, collapsible.trigger, collapsible.panel));
    return collapsible;
  }

  function toggle(trigger, panel) {
    isCollapsed(trigger) ? expand(trigger, panel) : collapse(trigger, panel);
  }

  function expand(trigger, panel) {
    trigger.setAttribute('aria-expanded', true);
    panel.removeAttribute('aria-hidden');
    // animate(panel, 'normal');
  }

  function collapse(trigger, panel) {
    trigger.setAttribute('aria-expanded', false);
    panel.setAttribute('aria-hidden', true);
    // animate(panel, 'reverse');
  }

  /**
   * Panel is next element with attr [data-collapsible-panel] after trigger or after trigger parent
   * @param {DOMElement} trigger
   * @return {DOMElement|null} panel element or null
   */
  function getPanelElement(trigger) {
    var triggerParent = trigger.parentElement;

    if (siblingIsPanel(trigger)) {
      return trigger.nextElementSibling;
    } else if (siblingIsPanel(triggerParent)) {
      return triggerParent.nextElementSibling;
    }

    return null;
  }

  /**
   * @param {DOMElement} element - trigger or trigger parent
   * @return {boolean} 
   */
  function siblingIsPanel(element) {
    return element.nextElementSibling && element.nextElementSibling.hasAttribute('data-collapsible-panel');
  }

  /**
   * @param {DOMElement} element - trigger [data-collapsible-title]
   * @return {boolean}
   */
  function isCollapsed(element) {
    return element.getAttribute('aria-expanded') === 'false';
  }

  /**
   * Animates collapsible panel
   * @param {DOMElement} element - [data-collapsible-panel]
   * @param {string} direction - animation direction
   */
  function animate(element, direction) {
    var type = direction === 'reverse' ? 'collapse' : 'expand';

    if (!typeof Element.prototype.animate === 'function') return;
    
    element.setAttribute('data-is-animating', true);
    
    var keyframes = [
      { height: getStartHeight(element) },
      { height: element.offsetHeight + 'px' }
    ];

    var options = {
      duration: 80,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    };
    
    element.animate(keyframes, options).onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }

  function getStartHeight(element) {
    var heightS = element.getAttribute('data-collapsible-panel-height-s');
    var heightL = element.getAttribute('data-collapsible-panel-height-l');
    var breakPoint = element.getAttribute('data-collapsible-panel-breakpoint');

    if (heightS && heightL && breakPoint) {
     return window.matchMedia('(max-width: ' + breakPoint + ')').matches
        ? heightS
        : heightL
    } else {
      return 0;
    }
  }
})();


function formatMoney(cents) {
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = '${{amount}}';

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);

}

/**
 * Feature detection.
 * @return {Object} Browser support.
 */
function getSupport() {
  return {
    WebAnimations: (typeof Element.prototype.animate === 'function')
  }
}

/**
 * Animate
 * @param {HTMLElement} element to animate.
 * @param {String} property Animation property.
 * @param {String} direction Animation direction, normal or reverse.
 * @return {undefined} Nothing to return.
 */
function animate(element, property, direction, duration) { 
  if (!support.WebAnimations) return;
  var keyframes;

  element.setAttribute('data-is-animating', true);
  
  if (property === 'height') {
    keyframes = [
      { height: 0 },
      { height: element.offsetHeight + 'px' }
    ]
  } else if (property === 'translateX') {
     keyframes = [
      { transform: 'translateX(-110%)' },
      { transform: 'translateX(0%)' }
    ]
  } else if (property === 'cartAnimation') {
     keyframes = [
      { transform: 'translateX(110%)' },
      { transform: 'translateX(0%)' }
    ]
  }

  element.animate(
    keyframes,
    { 
      duration: duration || 240,
      fill: 'both',
      easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      direction: direction
    }

  ).onfinish = function() {
    element.removeAttribute('data-is-animating');
    this.cancel();
  };
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function head(arr) {
  return arr[0];
}

function last(arr) {
  return arr[arr.length - 1];
}

function nodeList(str, root) {
  if (!root) root = document;
  var nodeList = root.querySelectorAll(str);
  return Array.prototype.slice.call(nodeList);
}

function partial(fn) {
  var slice = Array.prototype.slice;
  var args = slice.call(arguments, 1);
  return function() {
    return fn.apply(this, args.concat(slice.call(arguments, 0)));
  };
}

/**
 * Performs right-to-left function composition.
 * The rightmost function may have any arity, the remaining functions must be unary.
 * @example
 *   function plus1(n) {return n + 1};
 *   function plus2(n) {return n + 2};
 *   compose(plus2,plus1)(1) => 4
 * @return {Function} Composed function
 */
function compose() {
  var funcs = Array.prototype.slice.call(arguments).reverse();
  return function() {
    return funcs.slice(1).reduce(function(res, fn) {
      return fn(res);
    }, funcs[0].apply(undefined, arguments));
  };
}


document.addEventListener("contextmenu", function (e){
  e.preventDefault();
}, false);

